import { render, staticRenderFns } from "./AdjustRateSetting.vue?vue&type=template&id=2c9a6116&"
import script from "./AdjustRateSetting.vue?vue&type=script&lang=js&"
export * from "./AdjustRateSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports